import api from '@/lib/services/general.service'
import { toast } from 'vue3-toastify'

export const state = {
  categories: [],
  isLoading: false,
  activeFilterIds: [],
  showTasks: true,
}

export const getters = {
  categories: s => s.categories,
  activeFilterIds: s => s.activeFilterIds,
  getCategoryById: s => id => s.categories.find(c => c.id === id) ?? null,
  getCategoryColor: s => id => {
    const cat = s.categories.find(c => c.id === id)
    return cat?.color ?? null
  },
  showTasks: s => s.showTasks,
}

export const actions = {
  async fetchCategories({ commit }) {
    commit('SET_LOADING', true)
    try {
      const response = await api.get('calendar', {})
      if (response) commit('SET_CATEGORIES', response.data)
    } catch (e) {
      console.error('Error fetching calendars:', e)
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async addCategory({ commit }, request) {
    const toastId = toast.loading('Please wait...', { theme: 'event' })
    try {
      const response = await api.insert('calendar', request)
      if (response) {
        commit('ADD_CATEGORY', response.data)
        toast.update(toastId, { render: 'Calendar created', autoClose: true, closeOnClick: true, isLoading: false, theme: 'event' })
        toast.done(toastId)
        return response.data
      }
    } catch (e) {
      console.error('Error adding calendar:', e)
    }
    return null
  },

  async editCategory({ commit }, { id, request }) {
    try {
      const response = await api.patch('calendar', id, request)
      if (response) commit('UPDATE_CATEGORY', response.data)
    } catch (e) {
      console.error('Error editing calendar:', e)
    }
  },

  async deleteCategory({ commit }, id) {
    try {
      const response = await api.delete(`calendar`,id)
      if (response) commit('REMOVE_CATEGORY', id)
    } catch (e) {
      console.error('Error deleting calendar:', e)
    }
  },
}

export const mutations = {
  SET_LOADING(s, v) { s.isLoading = v },
  SET_CATEGORIES(s, cats) { s.categories = cats },
  ADD_CATEGORY(s, cat) { s.categories.push(cat) },
  UPDATE_CATEGORY(s, cat) {
    const idx = s.categories.findIndex(c => c.id === cat.id)
    if (idx !== -1) s.categories[idx] = cat
  },
  REMOVE_CATEGORY(s, id) {
    s.categories = s.categories.filter(c => c.id !== id)
    s.activeFilterIds = s.activeFilterIds.filter(i => i !== id)
  },
  TOGGLE_FILTER_ID(s, id) {
    const idx = s.activeFilterIds.indexOf(id)
    if (idx === -1) s.activeFilterIds.push(id)
    else s.activeFilterIds.splice(idx, 1)
  },
  TOGGLE_SHOW_TASKS(s) { s.showTasks = !s.showTasks },
}

export default { state, getters, actions, mutations }
